'use client';
import React from 'react';
import { gsap } from 'gsap';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ImageProps } from '@repo/ui/src/types/image';
import { buildStaticImage } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageForMask, VideoMaskContainer, VideoSilhouetteContainer } from './styles';

interface Props {
  image: ImageProps;
  mobile_image?: ImageProps;
  order?: number;
}

const ImageMask = ({ image, mobile_image, order }: Props) => {
  const reduceMotion = useMediaQuery('(prefers-reduced-motion)');
  const imageUrl = image?.image ? buildStaticImage({ name: image.image.name }) : '';
  const mobileImageUrl = mobile_image?.image
    ? buildStaticImage({ name: mobile_image.image.name })
    : '';
  const isPortrait = useMediaQuery((theme: any) => theme.breakpoints.down('md'));

  React.useEffect(() => {
    const zoomAnimation = gsap.to(`.video-mask`, {
      scale: 15,
      opacity: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: `.video-container`,
        scrub: 1,
        start: 'top top',
      },
    });

    return () => zoomAnimation?.scrollTrigger?.kill();
  }, []);

  const src = mobile_image && isPortrait ? mobileImageUrl : imageUrl;

  return reduceMotion ? null : (
    <VideoSilhouetteContainer className="video-container">
      <VideoMaskContainer order={order}>
        {src && (
          <ImageForMask
            src={src}
            className="video-mask"
            data-testid="video-mask"
            alt={image.altTag}
          />
        )}
      </VideoMaskContainer>
    </VideoSilhouetteContainer>
  );
};

export default ImageMask;
